/*============ Account Migration Page Controller
 ================================*/
angular
    .module('vppApp')
    .controller('accountMigrationController', accountMigrationController);

accountMigrationController.$inject = ['$window', '$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', '$stateParams', '$cookies', 'CreateAccountService'];

function accountMigrationController($window, $scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, $stateParams, $cookies, CreateAccountService) {

    $scope.siteCode = vppConfig.folderPath;

    $scope.user = {
        email: ""
    }

    apiFactory.getSsoUrl().then(function (response) {
        $scope.ssoUrl = response.data;
    });

    // API call to check status using input
    $scope.accountMigrationSubmit = function (user) {

        var body = {
            email: user.email,
            siteCode: $scope.siteCode,
            language: 'english'
        };

        apiFactory.postDetermineRegistrationRoute(body).then(function(response){
            CreateAccountService.setAccountMigrationDetails(response.data);

            if(response.data.accountId){
                //this goes to common registration page
                $window.location.href = response.url;
            } else if (response.data.url){
                //this goes to common login page
                $window.location.href = response.url;
            } else {
                //this goes to common registration page
                $window.location.href = response.url;
            }
        }, function errorCallBack(response) {
            $scope.serverError = response.data.errors;
        });
    }
}
